import { lazy } from 'react';

export const CountryList = lazy(() => import('./country/CountryList'));
export const DistrictList = lazy(() => import('./district/DistrictList'));
export const StateList = lazy(() => import('./state/StateList'));
export const TehsilList = lazy(() => import('./tehsil/TehsilList'));
export const CityList = lazy(() => import('./city/CityList'));
export const CategoryList = lazy(() => import('./category/CategoryList'));
export const SubCategoryList = lazy(() => import('./sub_category/SubCategoryList'));
export const ServiceList = lazy(() => import('./service/ServiceList'));
export const PlanList = lazy(() => import('./plan/PlanList'));
export const DesignationList = lazy(() => import('./designation/DesignationList'));
export const ExpenseCategoryList = lazy(() => import('./expenseCategory/ExpenseCategoryList'));